export default "<iframe *ngIf=\"!loading\" id=\"myIframe\"  runat=\"server\"  name=\"frame\" [src]=\"safeUrl\"  width=\"100%\" height=\"780px\" ></iframe>\n"